<template>
    <div id="app">
        <router-view/>
    </div>
</template>

<script>
export default {

}
</script>

<style src="alertifyjs/build/css/alertify.css"></style>
<style src="alertifyjs/build/css/themes/default.css"></style>
